import React from 'react';
import { ChevronRight, CalendarDays, UserRound, TrendingUp, Globe, CornerDownRight } from 'lucide-react';
import { heroFeatures, heroImage } from '../mock';

const iconMap = { UserRound, TrendingUp, CalendarDays, Globe };

const Hero = ({ onBook }) => {
  return (
    <section id="home" className="relative min-h-screen pt-24 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={require('./images/badukimage5.jpg')}
          alt="Go board with stones"
          className="absolute inset-0 w-full h-full  object-cover object-right"
        />
        {/* Gradient overlay: dark on the left to make text readable */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/85 to-[#0a0a0a]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-10 lg:pt-20 pb-32">
        <div className="max-w-3xl">
          <p className="text-amber-400 tracking-[0.32em] text-[13px] mb-8 font-medium">
            ONLINE GO LESSONS
          </p>
          <h1 className="font-serif text-white text-5xl sm:text-6xl lg:text-[88px] leading-[1.02] tracking-tight">
            Improve Your<br />
            Go Game<br />
            With <span className="text-amber-400 italic">Personal Lessons</span>
          </h1>

          <div className="mt-10 w-16 h-px bg-amber-400" />

          <p className="mt-8 text-white/80 text-lg max-w-xl leading-relaxed">
            1-on-1 online lessons for beginners and serious players.<br />
            Personalized instruction. Flexible scheduling. Real improvement.
          </p>

          <div className="mt-12 relative">
            <button
              onClick={onBook}
              className="group relative inline-flex items-center gap-4 bg-amber-400 hover:bg-amber-300 text-[#0a0a0a] pl-7 pr-6 py-5 rounded-full text-lg font-medium transition-all duration-300 shadow-[0_0_60px_-15px_rgba(245,180,68,0.7)] hover:shadow-[0_0_80px_-10px_rgba(245,180,68,0.9)] min-w-[360px] justify-between"
            >
              <span className="flex items-center gap-3">
                <CalendarDays size={22} strokeWidth={1.8} />
                Book Your Lesson Now
              </span>
              <ChevronRight size={22} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>

            <div className="mt-6 flex items-start gap-3 text-white/70 max-w-md">
              <CornerDownRight size={18} className="text-amber-400 mt-1 shrink-0 -scale-x-100" />
              <p className="text-[15px] leading-relaxed">
                Choose a time that works for you.<br />
                Takes less than <span className="text-amber-400 font-medium">30 seconds.</span>
              </p>
            </div>
          </div>
        </div>

        {/* Feature row */}
        <div className="mt-24 lg:mt-32 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {heroFeatures.map((f) => {
            const Icon = iconMap[f.icon];
            return (
              <div key={f.title} className="flex items-start gap-4 group">
                <div className="w-12 h-12 rounded-full border border-amber-400/60 flex items-center justify-center shrink-0 group-hover:border-amber-400 group-hover:bg-amber-400/10 transition-all duration-300">
                  <Icon size={22} className="text-amber-400" strokeWidth={1.7} />
                </div>
                <div>
                  <h3 className="text-white font-medium text-[17px] mb-1">{f.title}</h3>
                  <p className="text-white/60 text-[14px] leading-relaxed">{f.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;
